import React, { FC } from 'react';
import { isEmpty } from 'lodash';
import { ArticleInteractions } from './ArticleInteractions';
import { TArticleInteractionData } from './ArticleInteractions/types';
import ArticleToolbarTimepoints from './ArticleToolbarTimepoints';
import ArticleToolbarCommentsCounter from './ArticleToolbarCommentsCounter';
import ArticleHeaderInfoToolbarElement from './ArticleHeaderInfoToolbarElement';
import { ArticleHeaderInfoToolbarInteractionsContainer } from '../ArticleHeaderInfoToolbarInteractions/ArticleHeaderInfoToolbarInteractionsContainer';

type TArticleHeaderInfoToolbarProps = {
  id: string;
  totalTimePointsAccumulated: string;
  usersWhoReadArticle?: TArticleInteractionData[];
  commentsCount?: number;
  slug: string;
};

const ArticleHeaderInfoToolbar: FC<TArticleHeaderInfoToolbarProps> = ({
  id,
  totalTimePointsAccumulated,
  usersWhoReadArticle = [],
  commentsCount = 0,
  slug,
}) => {
  const toolbarItems = [
    {
      id: '1',
      element: <ArticleToolbarTimepoints totalTimePointsAccumulated={totalTimePointsAccumulated} />,
      shouldDisplay: true,
      hideOnMobiles: false,
    },
    {
      id: '2',
      element: <ArticleHeaderInfoToolbarInteractionsContainer articleSlug={slug} articleId={id} />,
      shouldDisplay: true,
      hideOnMobiles: true,
    },
    {
      id: '3',
      element: <ArticleToolbarCommentsCounter commentsCount={commentsCount} />,
      shouldDisplay: true,
      hideOnMobiles: true,
    },
    {
      id: '4',
      element: (
        <ArticleInteractions
          modalLabel="Readers"
          heading="who read it"
          usersWhoInteractWithArticle={usersWhoReadArticle}
          totalInteractionsCount={usersWhoReadArticle?.length}
        />
      ),
      shouldDisplay: !isEmpty(usersWhoReadArticle),
      hideOnMobiles: false,
    },
  ];

  return (
    <div className="flex mt-6 gap-x-2 md:gap-x-6 items-center justify-center">
      {toolbarItems
        .filter(({ shouldDisplay }) => shouldDisplay)
        .map((item, index) => {
          const isFirst = index === 0;
          return (
            <ArticleHeaderInfoToolbarElement hideOnMobiles={item.hideOnMobiles} isFirst={isFirst} key={item.id}>
              {item.element}
            </ArticleHeaderInfoToolbarElement>
          );
        })}
    </div>
  );
};
export default ArticleHeaderInfoToolbar;
